import styled, { css } from 'styled-components'

interface StyledIconProps {
  src?: string
  color?: string | null
  contentSize?: string | null
  contentWidth?: string | null
  contentHeight?: string | null
}

export const StyledIcon = styled.i.attrs<StyledIconProps>(
  ({ src, color, contentSize, contentWidth, contentHeight, ...props }) => props
)<StyledIconProps>`
  display: inline-block;
  vertical-align: baseline;
  mask-position: center;
  mask-repeat: no-repeat;
  mask-image: url('${(props) => props.src}');
  ${({ color }) =>
    color
      ? css`
          background: ${color};
        `
      : css`
          background: currentColor;
        `}
  ${({ contentSize, contentWidth, contentHeight }) =>
    contentSize
      ? css`
          mask-size: ${contentSize};
        `
      : contentWidth || contentHeight
      ? css`
          mask-size: ${contentWidth ?? 'auto'} ${contentHeight ?? 'auto'};
        `
      : css`
          mask-size: contain;
        `}
`
